import { render } from "./BuscarProductoModal.vue?vue&type=template&id=3f45adf9&scoped=true"
import script from "./BuscarProductoModal.vue?vue&type=script&lang=js"
export * from "./BuscarProductoModal.vue?vue&type=script&lang=js"

import "./BuscarProductoModal.vue?vue&type=style&index=0&id=3f45adf9&scoped=true&lang=css"
import "./BuscarProductoModal.vue?vue&type=style&index=1&id=3f45adf9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f45adf9"]])

export default __exports__